/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Guard_DescInputs */

const en_mk_loop_guard_desc = /** @type {(inputs: Mk_Loop_Guard_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep init installs task guard as a Stop hook: the session cannot end while a started task has no passing evidence.`)
};

const id_mk_loop_guard_desc = /** @type {(inputs: Mk_Loop_Guard_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep init memasang task guard sebagai hook Stop: sesi tidak bisa berhenti selama task yang sudah dimulai belum punya bukti lulus.`)
};

/**
* | output |
* | --- |
* | "bystep init installs task guard as a Stop hook: the session cannot end while a started task has no passing evidence." |
*
* @param {Mk_Loop_Guard_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_guard_desc = /** @type {((inputs?: Mk_Loop_Guard_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Guard_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_guard_desc(inputs)
	return en_mk_loop_guard_desc(inputs)
});